import { render } from "./MagnifyPlusOutlineIcon.vue?vue&type=template&id=3ec0b4a4"
import script from "./MagnifyPlusOutlineIcon.vue?vue&type=script&lang=js"
export * from "./MagnifyPlusOutlineIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__